module.exports = __webpack_public_path__ + "static/media/2XL.778dca95.jpg";